import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import az from "./az";
import en from "./en";

const resources = {
  en,
  az,
};

i18n.use(initReactI18next).init({
  resources,
  fallbackLng: localStorage.getItem("aztruck-lang") || "az",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
